// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__34HiA","filesListContainer":"PosDisputesFiles_filesListContainer__3lS4l","filesButton":"PosDisputesFiles_filesButton__1JOXR"};